import React, { useState } from "react";
import "./Checkout.css";
import NavbarComponent from "../../components/navbar/NavbarComponent";
import Footer from "../../components/footer/Footer";
import { useLocation } from "react-router-dom";
import { API } from "../../constants/Api";
import { toast } from "react-toastify";

function Checkout() {
  const location = useLocation();
  // const { data } = location.state || [];
  // const { total } = location.state || "";
  // const { ids } = location.state || [];
  // const { type } = location.state || "";
  // const { tourIds } = location.state || [];
  // const { offerIds } = location.state || [];
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  // Get data from localStorage
  const checkoutData = JSON.parse(localStorage.getItem("checkoutData")) || {};

  // Destructure with default values
  const {
    data = [],
    total = "",
    ids = [],
    type = "",
    tourIds = [],
    offerIds = [],
  } = checkoutData;

  // Optional: Clear the data after use
  // localStorage.removeItem('checkoutData');]]

  const [newTotal, setNewTotal] = useState(total);

  const [iscodeValid, setIsCodeValid] = useState(false);

  function codeValid() {
    if (code.length < 1) {
      toast.error("Promo code is required");
      return false;
    }

    return true;
  }
  const handleApplyPromo = async () => {
    const validate = await codeValid();

    if (validate) {
      const data = {
        code,
      };
      const validationResponse = await fetch(`${API}/discount/validate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      const json = await validationResponse.json();

      if (validationResponse.ok) {
        setIsCodeValid(true);
        if (code === "DDH50") {
          setNewTotal(Number(total) * 0.5);
        }
        // if (code === "DDH99") {
        //   setNewTotal(Number(total) * 0.01);
        // }
        if (code === "DDH100") {
          setNewTotal("0");
        }
      } else {
        toast.error(json.message);
      }
    }
  };

  const handlePayNow = async (e) => {
    e.preventDefault();

    const myData = {
      agentId: localStorage.getItem("agentId"),
      amount: newTotal,
      currency: "usd",
      email: localStorage.getItem("agentEmail"),
    };

    // if (type === "showing") {
    //   myData.schedulingTourId = ids;
    // }
    // if (type === "listing") {
    //   myData.makeAnOfferId = ids;
    // }

    // if (type === "tc") {
    //   myData.makeAnOfferId = offerIds;
    //   myData.schedulingTourId = tourIds;
    // }
    if (type === "showing") {
      myData.schedulingTourId = ids;
      myData.agentVendorType = "Showing Agent";
    }
    if (type === "listing") {
      myData.makeAnOfferId = ids;
      myData.agentVendorType = "Listing Agent";
    }
    if (type === "tc") {
      myData.makeAnOfferId = offerIds;
      myData.schedulingTourId = tourIds;
      myData.agentVendorType = "Transaction Coordinator";
    }
    setLoading(true);
    try {
      const response = await fetch(`${API}/stripe/create-payment-session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(myData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log(result);
        if(iscodeValid){
          const applyResponse = await fetch(`${API}/discount/apply`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              code: code,
              originalAmount: total,
            }),
          });
  
          const newResult = await applyResponse.json();
          if (applyResponse.ok) {
            window.location.href = result.checkoutUrl;
          } else {
            toast.error(newResult.message);
          }
        }else{
          window.location.href = result.checkoutUrl;
        }
      
    
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsCodeValid(false);
      setLoading(false);
      setCode("")
    }
  };
  return (
    <>
      <div className="advertiser-details">
        <NavbarComponent />
        <div
          className="container-fluid px-0"
          style={{ paddingBottom: "120px" }}
        >
          <div className="row px-0 mx-0 advertiser-details-page-section-1">
            <div className="col-md-6 px-0 d-flex align-items-center">
              <div className="container-fluid px-0">
                <div className="row px-0 mx-0">
                  <div className="container-fluid">
                    <h2 className="agent-register-heading">Checkout</h2>
                    {/* <p className="before-begin-span">Got any worries? No sweat, we’re here for you!</p> */}
                  </div>
                </div>
                <div className="row px-0 mx-0">
                  <div className="container-fluid checkout-page-card-3">
                    <div className="row">
                      {data ? (
                        <div className="col-12 px-0 pt-4">
                          <table className="table lead-table">
                            <tbody className="lead-table-body">
                              {data.map((tour) => (
                                <tr
                                  key={tour._id}
                                  className="lead-table-body-row"
                                >
                                  <td className="lead-table-data-1">
                                    <div className="lead-table-layout-content-header-box">
                                      <div className="lead-table-layout-content-header-image">
                                        {tour.houseImages.length > 0 ? (
                                          <img
                                            src={tour.houseImages[0]}
                                            className="lead-table-layout-content-header-image-media img-fluid"
                                            alt=""
                                          />
                                        ) : (
                                          <>
                                            <img
                                              src="/img/aqdas.jpeg"
                                              className="lead-table-layout-content-header-image-media img-fluid"
                                              alt=""
                                            />
                                          </>
                                        )}
                                      </div>
                                      <div className="lead-table-layout-content-header-details">
                                        <h3 className="lead-table-layout-content-header-details-name my-0">
                                          {tour.houseAddress}
                                        </h3>
                                        <p className="lead-table-layout-content-header-details-zipcode my-0">
                                          {tour.houseZipCode}
                                        </p>
                                      </div>
                                    </div>
                                  </td>

                                  <td className="lead-table-data-last">
                                    <div className="checkout-date w-100 pe-3 text-end">
                                      ${tour.price}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-12 devider-lead"></div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <h2 className="checkout-grand-total">Total</h2>
                      </div>
                      <div className="col-md-6 text-end">
                       
                        <h2 className={`${iscodeValid? "checkout-grand-total-price-through": "checkout-grand-total-price"}`}>
                        ${total}
                      </h2>
                     
                      </div>
                    </div>
                    {
                      iscodeValid?
                      <>
                       <div className="row">
                      <div className="col-md-6">
                       
                      </div>
                      <div className="col-md-6 text-end">
                        <h2 className="checkout-grand-total-price">
                          ${newTotal}
                        </h2>
                      </div>
                    </div>
                      </>
                      :
                      <></>
                    }
                   
                    <div className="row">
                      <div className="col-12 devider-lead"></div>
                    </div>
                    <div className="row">
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="form-control agent-register-input-field"
                          id="exampleInputEmail1"
                          placeholder="Promo Code (if any)"
                          aria-describedby="emailHelp"
                          value={code}
                          onChange={(e) => setCode(e.target.value)}
                        />
                      </div>
                      <div className="col-md-4">
                        <button
                          onClick={handleApplyPromo}
                          className="btn schedule-tour-skip-button"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        {loading ? (
                          <button className="btn agent-register-button">
                            Processing...
                          </button>
                        ) : (
                          <button
                            onClick={handlePayNow}
                            className="btn agent-register-button"
                          >
                            Pay Now
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 px-0 d-none d-lg-block justify-centent-end align-items-center">
              <div className="container-fluid d-flex justify-content-end">
                <img
                  src="/img/checkout.svg"
                  className="img-fluid checkout-image"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Checkout;
